export function getQueryParam(key: string): string | undefined {
    return new URLSearchParams(window.location.search).get(key) ?? undefined;
}
